import cn from 'classnames';
import { FC, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Icon } from '@/shared/ui';

import { DiagnocoinFunding } from '@/entities/billing';

import styles from './ReportCardFooter.module.scss';

type ReportCardFooterProps = {
  isReportFailed: boolean;
  isReportSigned: boolean;
  reorderFunding: DiagnocoinFunding;
  canReorder: boolean;
  isReorderDisabled: boolean;
  className?: string;
  // On a light surface (list rows) the signed badge needs a tinted background
  // instead of the translucent overlay used on report previews
  light?: boolean;
  onReorder: () => void;
};

export const ReportCardFooter: FC<ReportCardFooterProps> = (props) => {
  const {
    isReportFailed,
    isReportSigned,
    reorderFunding,
    canReorder,
    isReorderDisabled,
    className,
    light,
    onReorder,
  } = props;

  if (!isReportSigned && !isReportFailed) {
    return null;
  }

  const handleReorder = (event: MouseEvent) => {
    event.stopPropagation();

    onReorder();
  };

  return (
    <footer className={cn(styles.footer, 'p2', className)}>
      {isReportSigned && (
        <div className={cn(styles.signed, light && styles.lightSigned)}>
          <Icon name="check" size={24} />

          <FormattedMessage id="reportCard.signed" defaultMessage="Signed" />
        </div>
      )}

      {isReportFailed && canReorder && (
        <Button
          variant="secondary"
          onClick={handleReorder}
          size="medium"
          className={styles.reorder}
          disabled={isReorderDisabled}
        >
          {reorderFunding.source === 'diagnocoins' ? (
            <FormattedMessage
              id="reportCard.regenerateForCoins"
              defaultMessage="Regenerate for {coins, plural, one {# coin} other {# coins}}"
              values={{ coins: reorderFunding.coins }}
            />
          ) : (
            <FormattedMessage
              id="reportCard.regenerate"
              defaultMessage="Regenerate"
            />
          )}
        </Button>
      )}
    </footer>
  );
};
